import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Modal,
} from "react-bootstrap";
import PageTitle from "../components/common/PageTitle";
import { useTranslation } from "react-i18next";

import api from "../api/api";
import swal from "sweetalert";
import Pagination from "../views/Pagination";
import "./ConfigurationManagement.css";

const ConfigurationSoils = () => {
  const [soilsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [SearchName, setSearchName] = useState("");

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { t } = useTranslation();

  const [allSoils, setAllSoils] = useState([]);

  const [soilData, setSoilData] = useState({
    soil: "",
    ru: "",
    pwp: "",
    taw: "",
    fc: "",
    fractionRuPratique: "",
    EffPluie: "",
    soilAr: "",
    soilEn: "",
    soilPhoto: "",
  });

  const [toggle, setToggle] = useState(false);
  const [toggleEdit, setToggleEdit] = useState(false);
  const [singleSoil, setSingleSoil] = useState({});

  const getSoils = async () => {
    try {
      await api
        .get("/soils/get-soils")
        .then((response) => {
          let listSoils = response.data.Soils;
          setAllSoils(listSoils);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getSoils();
  }, []);

  const getSingleSoil = (soilId, title) => {
    let data = {
      soil_id: soilId,
    };

    api
      .post("/soils/get-soil", data)
      .then((res) => {
        let dataSoils = res.data.soil;
        setSingleSoil(dataSoils);
        setSoilData({
          soil: dataSoils.soil,
          ru: dataSoils.ru,
          fc: dataSoils.fc,
          pwp: dataSoils.pwp,
          taw: dataSoils.taw,
          EffPluie: dataSoils.rain_eff,
          fractionRuPratique: dataSoils.practical_fraction,
        });
      })
      .catch((error) => {
        console.error(error);
      });
    if (title === "Edit") {
      setToggleEdit(!toggleEdit);
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onFileUploadEdit = async () => {
    if (!selectedFile) {
      swal(t("error"), t("please_select_file_first"), "error");
      return;
    }

    const formData = new FormData();
    formData.append("photo", selectedFile);
    formData.append("soil", singleSoil.soil);

    try {
      const res = await api.post("/soil/upload-photo", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setUploadedFile(res.data);
    } catch (err) {
      console.error(err);
    }
  };

const addSoils = () => {
  let data = {
    soil: soilData.soil,
    ru: soilData.ru,
    fc: soilData.fc,
    pwp: soilData.pwp,
    taw: soilData.taw,
    rain_eff: soilData.EffPluie,
    practical_fraction: soilData.fractionRuPratique,
    soil_ar: soilData.soilAr,
    soil_en: soilData.soilEn,
    soil_photo: soilData.soilPhoto,
  };

  api
    .post("/soils/add-soils", data)
    .then((response) => {
      if (response && response.data.type === "success") {
        swal(t("Soil_Added"), { icon: "success" });
        setToggle(false);
        getSoils();
      }
      if (response && response.data.type === "danger") {
        swal(t("Saving_Soil_Error"), { icon: "error" });
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

const handleEdit = (soilId) => {
  let data = {
    soil_id: soilId,
    soil: soilData.soil,
    ru: soilData.ru,
    fc: soilData.fc,
    pwp: soilData.pwp,
    taw: soilData.taw,
    rain_eff: soilData.EffPluie,
    practical_fraction: soilData.fractionRuPratique,
  };

  api
    .post("/soils/edit-soil", data)
    .then((response) => {
      if (response.data.type == "success") {
        swal(t("soil_has_been_updated"), { icon: "success" });
        setToggle(false);
        getSoils();
      }
      if (response.data.type && response.data.type == "danger") {
        swal({
          icon: "error",
          title: t("Oops..."),
          text: t("error_edit_soil"),
        });
        return false;
      }
    })
    .catch((error) => {
      swal({
        icon: "error",
        title: t("Oops..."),
        text: t("error_edit_soil"),
      });
    });
};

const handleDelete = async (soilId) => {
  let data = {
    soil_id: soilId,
  };
  return await api
    .delete("/soils/delete-soil", { data: data })
    .then((response) => {
      if (response.data.type && response.data.type == "danger") {
        swal({
          title: t("Cannot_Delete_soil"),
          icon: "warning",
        });
        return false;
      }
      if (response.data.type == "success") {
        getSoils();
        return true;
      }
      return false;
    })
    .catch((error) => {
      swal({
        title: t("Cannot_Delete_soil"),
        icon: "error",
        text: t("error_delete_crop"),
      });
      return false;
    });
};

const confirmDelete = (soilId) => {
  swal({
    title: t("Are_You_Sure"),
    text: t("Delete_Soil_Warning"),
    icon: "warning",
    buttons: true,
    dangerMode: true,
  })
    .then(async (Delete) => {
      if (Delete) {
        const deleted = await handleDelete(soilId);
        if (deleted) {
          swal(t("Soil_Deleted"), { icon: "success" });
        }
      }
    })
    .catch((error) => {
      swal({
        title: t("Cannot_Delete_soil"),
        icon: "error",
        text: t("error_delete_soil"),
      });
    });
};


  const filteredSoils = allSoils.filter((soils) => {
    if (SearchName !== "") {
      return soils.soil.toLowerCase().includes(SearchName.toLowerCase());
    }

    return soils;
  });

  const indexOfLastPost = currentPage * soilsPerPage;
  const indexOfFirstPost = indexOfLastPost - soilsPerPage;
  const currentSoils = filteredSoils.slice(indexOfFirstPost, indexOfLastPost);

  return (
    <>
      <Container className="management-page admin-management-page configuration-management-page p-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={t("Soils_Configuration")}
            subtitle={t("Soils_Configuration")}
            className="text-sm-left"
          />
        </Row>
        <Row>
          <PageTitle sm="4" subtitle={t("search")} className="text-sm-left" />
        </Row>
        <Row form className="d-flex justify-content-center">
          <Col md="3" className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  value={SearchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  id="search"
                  placeholder={t("search_by_name")}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <PageTitle
            sm="4"
            subtitle={t("my_actions")}
            className="text-sm-left"
          />
        </Row>
        <Row form className="py-2 d-flex justify-content-center">
          <ButtonGroup>
            <Button
              variant="outline-primary"
              onClick={() => {
                setToggle(true);
              }}
            >
                {t("Add_Soil_Type")}
              
            </Button>
          </ButtonGroup>
        </Row>
        <Card>
          <Card.Header className="border-bottom">
            <div>
              <h5>                {t("Soils_info")}
</h5>
            </div>
          </Card.Header>
          <Card.Body>
            <table className="table mb-0 text-center  table-responsive-lg">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    {t("Soil_Type")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("RU %")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("Irrigation_Efficiency %")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("PWP %")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("TAW %")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("Rain_efficiency %")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("Practical_fraction %")}
                  </th>
                  <th scope="col" className="border-0"></th>
                </tr>
              </thead>
              <tbody>
                {currentSoils.map((soil) => {
                  return (
                    <tr key={soil.id}>
                      <td>{t(soil.soil.trim())}</td>
                      <td>{soil.ru}</td>
                      <td>{soil.fc}</td>
                      <td>{soil.pwp}</td>
                      <td>{soil.taw}</td>
                      <td>{soil.rain_eff}</td>
                      <td>{soil.practical_fraction}</td>

                      <td>
                        <ButtonGroup size="sm" className="mr-2 configuration-action-group">
                          <Button
                            title={t('edit')}
                            onClick={() => {
                              getSingleSoil(soil.id, "Edit");
                            }}
                            className="configuration-action-button"
                          >
                            <i className="fas fa-pen" aria-hidden="true" />
                          </Button>
                          <Button
                            title={t('delete')}
                            onClick={() => {
                              confirmDelete(soil.id);
                            }}
                            className="configuration-action-button"
                            variant="danger"
                          >
                            <i className="fas fa-trash" aria-hidden="true" />
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card.Body>
        </Card>
        <Row className="py-4 justify-content-center">
          <Pagination
            usersPerPage={soilsPerPage}
            totalUsers={filteredSoils.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </Row>
      </Container>
      <Modal size="lg" centered={true} show={toggle} onHide={() => setToggle(false)}>
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <Button
              // theme="success"
              onClick={() => {
                addSoils();
              }}
              className="mb-2 mr-1 btn btn-success"
            >
              <i className="fa fa-check mx-2"></i>
              {t("save")}
            </Button>
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              onClick={() => {
                setToggle(false);
              }}
            >
              <i className="fa fa-times mx-2"></i>
              {t("cancel")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12" md="12" sm="12">
<Card.Body>
  <Row className="gap-2">
    <Col lg="5" md="12" sm="12">
      <Form.Group>
        <label htmlFor="soil">{t("Soil_Type")}</label>
        <Form.Control
          id="soil"
          placeholder={t("Soil_Type")}
          value={soilData.soil}
          onChange={(e) =>
            setSoilData({ ...soilData, soil: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="5" md="12" sm="12">
      <Form.Group>
        <label htmlFor="soilAr">{t("Soil_Type_Ar")}</label>
        <Form.Control
          id="soilAr"
          placeholder={t("Soil_Type_Ar")}
          value={soilData.soilAr}
          onChange={(e) =>
            setSoilData({ ...soilData, soilAr: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="5" md="12" sm="12">
      <Form.Group>
        <label htmlFor="soilEn">{t("Soil_Type_En")}</label>
        <Form.Control
          id="soilEn"
          placeholder={t("Soil_Type_En")}
          value={soilData.soilEn}
          onChange={(e) =>
            setSoilData({ ...soilData, soilEn: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    {/* <Col lg='6' md="12" sm="12">
      <Form.Group>
        <label htmlFor="soilp">{t("Soil_Photo")}</label>
        <Form.Control
          id='soilp'
          type="file"
          placeholder={t("Soil_Photo")}
          value={soilData.soilPhoto}
          onChange={onFileChange}
        />
        <button style={{background :"#E5E5E5" , border:"2px solid #d7d7d7",borderRadius:5,padding:3,margin:3}} onClick={onFileUpload}>{t("Upload")}</button>
      </Form.Group>
    </Col> */}
    <Col lg="5" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="Ru">{t("RU_Percentage")}</label>
        <Form.Control
          id="Ru"
          value={soilData.ru}
          onChange={(e) =>
            setSoilData({ ...soilData, ru: e.target.value })
          }
        />
      </Form.Group>
    </Col>
  </Row>
  <Row className="gap-2 mt-2">
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="pwp">{t("PWP_Percentage")}</label>
        <Form.Control
          id="pwp"
          placeholder={t("PWP_Percentage")}
          value={soilData.pwp}
          onChange={(e) =>
            setSoilData({ ...soilData, pwp: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="3" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="Fc">{t("Irrigation_Efficiency_Percentage")}</label>
        <Form.Control
          id="Fc"
          placeholder={t("Irrigation_Efficiency_Percentage")}
          value={soilData.fc}
          onChange={(e) =>
            setSoilData({ ...soilData, fc: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="taw">{t("TAW_Percentage")}</label>
        <Form.Control
          id="taw"
          placeholder={t("TAW_Percentage")}
          value={soilData.taw}
          onChange={(e) =>
            setSoilData({ ...soilData, taw: e.target.value })
          }
        />
      </Form.Group>
    </Col>
  </Row>
  <Row className="gap-2">
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="practicalFractionRu">
          {t("Practical_Fraction_Percentage")}
        </label>
        <Form.Control
          id="practicalFractionRu"
          placeholder={t("Practical_Fraction_Percentage")}
          value={soilData.fractionRuPratique}
          onChange={(e) => {
            setSoilData({
              ...soilData,
              fractionRuPratique: e.target.value,
            });
          }}
        />
      </Form.Group>
    </Col>
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="rainEfficiency">{t("Rain_Efficiency_Percentage")}</label>
        <Form.Control
          id="rainEfficiency"
          placeholder={t("Rain_Efficiency_Percentage")}
          value={soilData.EffPluie}
          onChange={(e) => {
            setSoilData({
              ...soilData,
              EffPluie: e.target.value,
            });
          }}
        />
      </Form.Group>
    </Col>
  </Row>
  <Form.Group className="mt-2">
    <label htmlFor="feDescription">{t("desc")}</label>
    <Form.Control
      as="textarea"
      placeholder={t("desc")}
      id="feDescription"
      rows="3"
    />
  </Form.Group>
</Card.Body>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal size="lg" centered={true} show={toggleEdit} onHide={() => setToggleEdit(false)}>
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <Button
              // theme="success"
              onClick={() => {
                handleEdit(singleSoil.id);
              }}
              className="mb-2 mr-1 btn btn-success"
            >
              <i className="fa fa-check mx-2"></i>
              {t("save")}
            </Button>
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              onClick={() => {
                setToggleEdit(false);
              }}
            >
              <i className="fa fa-times mx-2"></i>
              {t("cancel")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12" md="12" sm="12">
<Card.Body>
  <Row className="gap-2">
    <Col lg="5" md="12" sm="12">
      <Form.Group>
        <label htmlFor="soil">{t("Soil_Type")}</label>
        <Form.Control
          id="soil"
          placeholder={t("Soil_Type")}
          value={soilData.soil}
          onChange={(e) =>
            setSoilData({ ...soilData, soil: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="6" md="12" sm="12">
      <Form.Group>
        <label htmlFor="soilAr">{t("Soil_Type_Ar")}</label>
        <Form.Control
          id="soilAr"
          placeholder={t("Soil_Type_Ar")}
          value={soilData.soilAr}
          onChange={(e) =>
            setSoilData({ ...soilData, soilAr: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="3" md="12" sm="12">
      <Form.Group>
        <label htmlFor="soilEn">{t("Soil_Type_En")}</label>
        <Form.Control
          id="soilEn"
          placeholder={t("Soil_Type_En")}
          value={soilData.soilEn}
          onChange={(e) =>
            setSoilData({ ...soilData, soilEn: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="4" md="12" sm="12">
      <Form.Group>
        <label htmlFor="soilp">{t("Soil_Photo")}</label>
        <Form.Control
          id="soilp"
          type="file"
          placeholder={t("Soil_Photo")}
          onChange={onFileChange}
        />
        <button
          style={{
            background: "#E5E5E5",
            border: "2px solid #d7d7d7",
            borderRadius: 5,
            padding: 3,
            margin: 3,
          }}
          onClick={onFileUploadEdit}
        >
          {t("Upload")}
        </button>
        {uploadedFile?.message ? (
          <h6 style={{ fontWeight: "bold" }}>{uploadedFile.message}</h6>
        ) : null}
      </Form.Group>
    </Col>
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="Ru">{t("RU_Percentage")}</label>
        <Form.Control
          id="Ru"
          value={soilData.ru}
          onChange={(e) =>
            setSoilData({ ...soilData, ru: e.target.value })
          }
        />
      </Form.Group>
    </Col>
  </Row>
  <Row className="gap-2">
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="pwp">{t("PWP_Percentage")}</label>
        <Form.Control
          id="pwp"
          placeholder={t("PWP_Percentage")}
          value={soilData.pwp}
          onChange={(e) =>
            setSoilData({ ...soilData, pwp: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="3" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="Fc">{t("Irrigation_Efficiency_Percentage")}</label>
        <Form.Control
          id="Fc"
          placeholder={t("Irrigation_Efficiency_Percentage")}
          value={soilData.fc}
          onChange={(e) =>
            setSoilData({ ...soilData, fc: e.target.value })
          }
        />
      </Form.Group>
    </Col>
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="taw">{t("TAW_Percentage")}</label>
        <Form.Control
          id="taw"
          placeholder={t("TAW_Percentage")}
          value={soilData.taw}
          onChange={(e) =>
            setSoilData({ ...soilData, taw: e.target.value })
          }
        />
      </Form.Group>
    </Col>
  </Row>
  <Row className="gap-2">
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="practicalFractionRu">
          {t("Practical_Fraction_Percentage")}
        </label>
        <Form.Control
          id="practicalFractionRu"
          placeholder={t("Practical_Fraction_Percentage")}
          value={soilData.fractionRuPratique}
          onChange={(e) => {
            setSoilData({
              ...soilData,
              fractionRuPratique: e.target.value,
            });
          }}
        />
      </Form.Group>
    </Col>
    <Col lg="4" md="12" sm="12">
      <Form.Group className="d-flex justify-content-center align-items-center flex-column">
        <label htmlFor="rainEfficiency">{t("Rain_Efficiency_Percentage")}</label>
        <Form.Control
          id="rainEfficiency"
          placeholder={t("Rain_Efficiency_Percentage")}
          value={soilData.EffPluie}
          onChange={(e) => {
            setSoilData({
              ...soilData,
              EffPluie: e.target.value,
            });
          }}
        />
      </Form.Group>
    </Col>
  </Row>
  <Form.Group>
    <label htmlFor="feDescription">{t("desc")}</label>
    <Form.Control
      as="textarea"
      placeholder={t("desc")}
      id="feDescription"
      rows="3"
    />
  </Form.Group>
</Card.Body>

            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfigurationSoils;
